// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  platform: 'desktop',
  //baseUrl: 'https://localhost:44350',
  baseUrl: 'https://devapi.eventum.rs',
  //baseUrl: 'https://api.eventum.rs',
  //baseUrl: 'https://localhost:5001',
  baseAddress: 'http://localhost:8100',
  port: 8101,
  facebook: {
    appId: '326404332600512',
    scope: 'public_profile,email'
  },
  setOnTopPrice: 'set_ad_on_top_price',
  maxAllowedDebt: 'max_allowed_debt',
  detailDate: '2022-12-28T10:00:00'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
